import { darken } from 'polished';
import styled from 'styled-components';
import colors from '~/styles/colors';

import ReactSelect from '~/components/ReactSelect';

export const Container = styled.div`
  max-width: 94rem;
  margin: 5rem auto;
  flex: 1;
  h1,
  h2 {
    text-align: center;
  }
  form {
    display: flex;
    flex-direction: column;
    margin-top: 30px;

    h2 {
      margin: 3rem 0 1rem;
      flex: 1;
      background-color: ${colors.primary};
      color: #fff;
      padding: 1.2rem;
    }

    label {
      margin: 3rem 0 1rem;
      flex: 1;
      background-color: ${colors.primary};
      color: #fff;
      padding: 1.2rem;
      font-weight: bold;
      font-size: 2rem;
    }
    textarea {
      background: white;
      border: 0;
      border-radius: 4px;
      height: 200px;
      padding: 20px;
      color: #000;
      margin: 0 0 10px;
      font-size: 18px;
      resize: none;

      &::placeholder {
        color: #999;
      }
    }
    input,
    select {
      background: white;
      border: 0;
      border-radius: 4px;
      height: 50px;
      padding: 0px 20px;
      color: #000;
      margin: 0 0 10px;
      font-size: 18px;
      width: 940px;

      &::placeholder {
        color: #999;
      }
      &:disabled {
        background: ${darken(0.2, 'white')};
      }
    }
    span {
      color: red;
      align-self: flex-start;
      margin-bottom: 10px;
      font-weight: bold;
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;

  button {
    padding: 12px 20px;
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    margin: 10px 0 0;
    background: ${colors.primary};
    font-weight: bold;
    color: #fff;
    border: 0;
    border-radius: 4px;
    font-size: 16px;
    transition: background 0.2s;

    &:hover {
      background: ${darken(0.08, colors.primary)};
    }
    svg {
      margin-right: 10px;
    }
  }
`;

export const SearchSelect = styled(ReactSelect).attrs({
  className: 'Select',
})`
  .Select__control {
    width: 100%;
  }
  .Select__value-container {
    height: 50px;
  }
`;
